import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=5019041d&"
import script from "./CustomerDetails.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports